function FramesManager(ApiManager) {

    const framesList = [{
        name: "applicationFrame",
        endpoint: "/systemcontext"
    }];

    const frames = new Map();

    this.getFrame = function() {
        return frames.get('applicationFrame');
    };

    this.initialise = async function() {
        return Promise.all(
            framesList.map(frameDetail => async function() {
                const frame = await ApiManager.getData(frameDetail.endpoint);
                const frameData = await frame.json();
                frames.set(frameDetail.name, frameData);				
            }())
        );
    };

}

export default FramesManager;